import React, { useEffect, useState, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, Navigate, useNavigate } from "react-router-dom";
import moment from "moment";
import QRCode from "qrcode";
import Drawer from "@mui/material/Drawer";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Sidebar from "../../components/Sidebar";
import PropTypes from "prop-types";
import LinearProgress from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";
import { alertMessage } from "../../actions/auth";
import { Bar } from "react-chartjs-2";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import TextField from "@mui/material/TextField";
import Avatar from "@mui/material/Avatar";
import axios from "axios";
import CircularProgress from "@mui/material/CircularProgress";
import { Chart } from "chart.js/auto";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { Fab } from "@mui/material";
import Fade from "@mui/material/Fade";
import IconButton from "@mui/material/IconButton";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Checkbox from "@mui/material/Checkbox";
import DownloadIcon from "@mui/icons-material/Download";
import QrCodeIcon from "@mui/icons-material/QrCode";
import PublishIcon from "@mui/icons-material/Publish";
import SaveIcon from "@mui/icons-material/Save";
import SearchOffIcon from "@mui/icons-material/SearchOff";
import CloseIcon from "@mui/icons-material/Close";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import EditIcon from "@mui/icons-material/Edit";
import UploadIcon from "@mui/icons-material/Upload";
import { API_URL } from "../../actions/auth";
import { themeStyle } from "../../components/Components";
import { FormControlLabel } from "@mui/material";
import { styled } from "@mui/material";
import { CloudUpload, Description, Close } from "@mui/icons-material";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";

const Dropzone = styled("div")(({ theme }) => ({
  border: `2px dashed ` + themeStyle.primaryColor,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(6),
  textAlign: "center",
  cursor: "pointer",
}));

const FileUploadCard = () => {
  return (
    <Box sx={{ maxWidth: 400, mx: "auto", marginBottom: "50px" }} elevation={1}>
      <Dropzone>
        <CloudUpload
          fontSize="large"
          sx={{ color: themeStyle.primaryColor, mb: 1, fontSize: "50px" }}
        />
        <Typography variant="body1">Click here to upload your file</Typography>
        <Typography variant="caption" color="text.secondary">
          with .xlsx file extension (Max 25MB)
        </Typography>
      </Dropzone>
    </Box>
  );
};

function Students() {
  const dispatch = useDispatch();
  function createAlert(type, title, message) {
    dispatch(alertMessage(type, title, message));
  }
  const navigate = useNavigate();
  const params = new URLSearchParams(window.location.search);
  const state = useSelector((state) => state);
  const [isLoading, setIsLoading] = useState(true);
  const [ogStudents, setOGStudents] = useState([]);
  const [random, setRandom] = useState(0);
  const [search, setSearch] = useState("");
  const [profile, setProfile] = useState({});
  const [open, setOpen] = useState(false);
  const [isUploading, setIsUploading] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedFile, setSelectedFile] = useState("");
  const [classs, setClass] = useState("");
  const [division, setDivision] = useState("");
  const [studentList, setStudentList] = useState([]);
  const [classList, setClassList] = useState([]);
  const [classListOG, setClassListOG] = useState([]);
  const [toggleDrawer, setToggleDrawer] = useState(false);
  const [isClassLesser, setIsClassLesser] = useState(false);
  const [semester, setSemester] = useState(
    state.auth.classType == "STANDARDS" ? "Term" : ""
  );
  const [noClasses, setNoClasses] = useState(true);
  const [optionalSubjectsList, setOptionalSubjectsList] = useState([]);

  function handleSearch(text) {
    setSearch(text);
    if (text.length == 0) {
      setStudentList(ogStudents);
      setSearch("");
      setRandom(makeid(5));
    } else {
      var tempStudents = [];

      for (var i = 0; i < ogStudents.length; i++) {
        if (
          ogStudents[i]["full_name"]
            .toLowerCase()
            .includes(text.toLowerCase()) ||
          ogStudents[i]["email"].toLowerCase().includes(text.toLowerCase())
        ) {
          tempStudents.push(ogStudents[i]);
        }
      }
      setCurrentPage(1);
      setStudentList(tempStudents);
      setRandom(makeid(5));
    }
  }

  function changeOptionalSubjects() {
    setIsLoading(true);

    var body = {};
    const config = {
      headers: {
        Authorization: state.auth.token,
        "Content-Type": "application/json",
      },
    };
    body["user_id"] = profile.user_id;
    body["subject_list"] = profile.subject_list;

    body = JSON.stringify(body);
    axios
      .post(API_URL + "/save_student_subjects_manual", body, config)
      .then((res) => {
        createAlert(
          "SUCCESS",
          "Success.",
          "Subjects saved for " + profile.full_name
        );
        setOpen(false);
        getStudents(classs, division);
      });
  }

  function makeid(length) {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  function handleCurrentPage(val) {
    var tempStudents = Array.from(ogStudents);
    setSearch("");
    setCurrentPage(val);
    setStudentList(tempStudents.splice((val - 1) * 25, 25));
  }

  function getStudents(cla, div) {
    var body = {};
    const config = {
      headers: {
        Authorization: state.auth.token,

        "Content-Type": "application/json",
      },
    };
    body["class_id"] = cla;
    body["division"] = div;
    body["institution_id"] = state.auth.user.institution_id;
    body = JSON.stringify(body);

    axios
      .post(API_URL + "/get_students_list_class_division", body, config)
      .then((res) => {
        if (res.data.length != 0) {
          if (profile == null || JSON.stringify(profile) == "{}") {
            setProfile(res.data[0]);
          } else {
            for (var i = 0; i < res.data.length; i++) {
              if (res.data[i]["user_id"] == profile["user_id"]) {
                setProfile(res.data[i]);
                break;
              }
            }
          }
          setOGStudents(res.data);
          setStudentList(Array.from(res.data).splice(0, 25));
          setRandom(makeid(4));
        }
        setIsLoading(false);
      });
  }

  function handleClassChange(e) {
    setClass(e.target.value);
    setIsLoading(true);
    getStudents(e.target.value, division);
  }

  function handleDivisionChange(e) {
    setDivision(e.target.value);
    setIsLoading(true);
    getStudents(classs, e.target.value);
  }

  function getData(cla, div, sem) {
    var body = {};
    const config = {
      headers: {
        Authorization: state.auth.token,

        "Content-Type": "application/json",
      },
    };
    body["institution_id"] = state.auth.user.institution_id;
    body = JSON.stringify(body);

    axios.post(API_URL + "/get_class_list", body, config).then((res) => {
      setClassListOG(res.data);
      var tempOptionalSubejctsList = [];

      var allSubjects = res.data[cla][div][sem];

      for (var i = 0; i < allSubjects.length; i++) {
        if (!allSubjects[i][Object.keys(allSubjects[i])[0]]["compulsary"]) {
          tempOptionalSubejctsList.push(Object.keys(allSubjects[i])[0]);
        }
      }
      setOptionalSubjectsList(tempOptionalSubejctsList);
      setIsLoading(false);
    });
  }

  useEffect(() => {
    if (state.auth.isLoading) {
      dispatch({ type: "ENTRY_PAGE", payload: window.location.pathname });
      navigate("/", { replace: true });
    } else {
      var classListTemp = JSON.parse(state.auth.user.class_id_list);

      if (Object.keys(classListTemp).length == 0) {
        setIsLoading(false);
      } else {
        setNoClasses(false);

        setClassList(classListTemp);

        setSemester(
          state.auth.classType == "STANDARDS"
            ? "Term"
            : Object.keys(classListTemp)[0]
        );
        setClass(Object.keys(classListTemp[Object.keys(classListTemp)[0]])[0]);
        setDivision(
          Object.keys(
            classListTemp[Object.keys(classListTemp)[0]][
              Object.keys(classListTemp[Object.keys(classListTemp)[0]])[0]
            ]
          )[0]
        );

        getStudents(
          Object.keys(classListTemp[Object.keys(classListTemp)[0]])[0],
          Object.keys(
            classListTemp[Object.keys(classListTemp)[0]][
              Object.keys(classListTemp[Object.keys(classListTemp)[0]])[0]
            ]
          )[0]
        );
        getData(
          Object.keys(classListTemp[Object.keys(classListTemp)[0]])[0],
          Object.keys(
            classListTemp[Object.keys(classListTemp)[0]][
              Object.keys(classListTemp[Object.keys(classListTemp)[0]])[0]
            ]
          )[0],
          state.auth.classType == "STANDARDS"
            ? "Term"
            : Object.keys(classListTemp)[0]
        );
      }
    }
  }, []);

  function getClassList() {
    var classes = Object.keys(classList[semester]).map((classs, index) => (
      <MenuItem value={classs}>{classs}</MenuItem>
    ));

    return classes;
  }

  function getDivisionList() {
    var divisions = Object.keys(classList[semester][classs]).map(
      (division, index) => <MenuItem value={division}>{division}</MenuItem>
    );

    return divisions;
  }

  function getContent() {
    return (
      <div>
        {studentList.length == 0 ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: "40px",
            }}
          >
            <SearchOffIcon
              style={{
                fontSize: "200px",
                marginBottom: "20px",
                color: themeStyle.primaryColor,
              }}
            />
            <Typography variant="h6" style={{ color: themeStyle.primaryColor }}>
              No students found in the records for {classs} {division}
            </Typography>
          </div>
        ) : (
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                padding: "25px",
              }}
            >
              <Grid container spacing={3} justifyContent={"flex-end"}>
                <Grid item md={4} style={{ overflowX: "scroll" }}>
                  <div
                    style={{
                      backgroundColor: themeStyle.primaryCardColor,
                      borderRadius: "15px",
                      padding: "15px",
                      height: "100%",
                    }}
                  >
                    <div
                      style={{
                        color: themeStyle.primaryColor,
                        fontSize: "25px",
                        fontWeight: "bold",
                      }}
                    >
                      {profile.full_name ?? ""}
                    </div>
                    <br />
                    <span
                      style={{
                        fontSize: "20px",
                        color: themeStyle.secondaryColor,
                        fontWeight: "bold",
                      }}
                    >
                      Personal Information
                    </span>
                    <hr />

                    {/* <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "8px",
                      }}
                    >
                      <span>Roll Number:</span>
                      <span style={{ color: themeStyle.primaryColor }}>
                        {profile.roll_number ? (
                          profile.roll_number
                        ) : (
                          <span style={{ color: "#ff3333" }}>
                            NOT AVAILABLE
                          </span>
                        )}
                      </span>
                    </div> */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "8px",
                      }}
                    >
                      <span>Gender:</span>
                      <span style={{ color: themeStyle.primaryColor }}>
                        {profile.gender ? (
                          profile.gender
                        ) : (
                          <span style={{ color: "#ff3333" }}>
                            NOT AVAILABLE
                          </span>
                        )}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "8px",
                      }}
                    >
                      <span>Birthdate:</span>
                      <span style={{ color: themeStyle.primaryColor }}>
                        {profile.birthdate ? (
                          profile.birthdate
                        ) : (
                          <span style={{ color: "#ff3333" }}>
                            NOT AVAILABLE
                          </span>
                        )}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "8px",
                      }}
                    >
                      <span>Blood Group:</span>
                      <span style={{ color: themeStyle.primaryColor }}>
                        {profile.blood_group ? (
                          profile.blood_group
                        ) : (
                          <span style={{ color: "#ff3333" }}>
                            NOT AVAILABLE
                          </span>
                        )}
                      </span>
                    </div>

                    <br />
                    <span
                      style={{
                        fontSize: "20px",
                        color: themeStyle.secondaryColor,
                        fontWeight: "bold",
                      }}
                    >
                      Parents Information
                    </span>
                    <hr />

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "8px",
                      }}
                    >
                      <span>Mother's Name:</span>
                      <span style={{ color: themeStyle.primaryColor }}>
                        {profile.mother_name ? (
                          profile.mother_name
                        ) : (
                          <span style={{ color: "#ff3333" }}>
                            NOT AVAILABLE
                          </span>
                        )}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "8px",
                      }}
                    >
                      <span>Father's Name:</span>
                      <span style={{ color: themeStyle.primaryColor }}>
                        {profile.father_name ? (
                          profile.father_name
                        ) : (
                          <span style={{ color: "#ff3333" }}>
                            NOT AVAILABLE
                          </span>
                        )}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "8px",
                      }}
                    >
                      <span>Email:</span>
                      <span style={{ color: themeStyle.primaryColor }}>
                        {profile.email ? (
                          profile.email
                        ) : (
                          <span style={{ color: "#ff3333" }}>
                            NOT AVAILABLE
                          </span>
                        )}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "8px",
                      }}
                    >
                      <span>Phone Number:</span>
                      <span style={{ color: themeStyle.primaryColor }}>
                        {profile.phone_number ? (
                          profile.phone_number
                        ) : (
                          <span style={{ color: "#ff3333" }}>
                            NOT AVAILABLE
                          </span>
                        )}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "16px",
                      }}
                    >
                      <span>Alternate Phone:</span>
                      <span style={{ color: themeStyle.primaryColor }}>
                        {profile.alternate_phone_number ? (
                          profile.alternate_phone_number
                        ) : (
                          <span style={{ color: "#ff3333" }}>
                            NOT AVAILABLE
                          </span>
                        )}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "16px",
                      }}
                    >
                      <span>Guardian's Name:</span>
                      <span style={{ color: themeStyle.primaryColor }}>
                        {profile.guardian_name ? (
                          profile.guardian_name
                        ) : (
                          <span style={{ color: "#ff3333" }}>
                            NOT AVAILABLE
                          </span>
                        )}
                      </span>
                    </div>
                    <br />
                    <span
                      style={{
                        fontSize: "20px",
                        color: themeStyle.secondaryColor,
                        fontWeight: "bold",
                      }}
                    >
                      School Information
                    </span>
                    <hr />
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "8px",
                      }}
                    >
                      <span>CHSID:</span>
                      <span style={{ color: themeStyle.primaryColor }}>
                        {profile.user_id ? (
                          profile.user_id
                        ) : (
                          <span style={{ color: "#ff3333" }}>
                            NOT AVAILABLE
                          </span>
                        )}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "8px",
                      }}
                    >
                      <span>Type of Impairments:</span>
                      <span style={{ color: themeStyle.primaryColor }}>
                        {profile.type_of_impairments ? (
                          profile.type_of_impairments
                        ) : (
                          <span style={{ color: "#ff3333" }}>
                            NOT AVAILABLE
                          </span>
                        )}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "8px",
                      }}
                    >
                      <span>Social Category:</span>
                      <span style={{ color: themeStyle.primaryColor }}>
                        {profile.social_category ? (
                          profile.social_category
                        ) : (
                          <span style={{ color: "#ff3333" }}>
                            NOT AVAILABLE
                          </span>
                        )}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "8px",
                      }}
                    >
                      <span>Repeater:</span>
                      <span style={{ color: themeStyle.primaryColor }}>
                        {profile.is_repeater ? "Yes" : "No"}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "8px",
                      }}
                    >
                      <span>Aadhar No:</span>
                      <span style={{ color: themeStyle.primaryColor }}>
                        {profile.aadhar_no ? (
                          profile.aadhar_no
                        ) : (
                          <span style={{ color: "#ff3333" }}>
                            NOT AVAILABLE
                          </span>
                        )}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "8px",
                      }}
                    >
                      <span>Student PEN:</span>
                      <span style={{ color: themeStyle.primaryColor }}>
                        {profile.student_pen ? (
                          profile.student_pen
                        ) : (
                          <span style={{ color: "#ff3333" }}>
                            NOT AVAILABLE
                          </span>
                        )}
                      </span>
                    </div>
                    {state.auth.classType !== "STANDARDS" ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginBottom: "8px",
                        }}
                      >
                        <span>Current Semester:</span>
                        <span style={{ color: themeStyle.primaryColor }}>
                          {profile.current_semester ? (
                            profile.current_semester
                          ) : (
                            <span style={{ color: "#ff3333" }}>
                              NOT AVAILABLE
                            </span>
                          )}
                        </span>
                      </div>
                    ) : (
                      ""
                    )}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "8px",
                      }}
                    >
                      <span>Fees Paid:</span>
                      <span style={{ color: themeStyle.primaryColor }}>
                        {profile.fees_paid ? (
                          profile.fees_paid
                        ) : (
                          <span style={{ color: "#ff3333" }}>
                            NOT AVAILABLE
                          </span>
                        )}
                      </span>
                    </div>
                  </div>
                </Grid>
                <Grid
                  item
                  md={8}
                  style={{
                    overflowY: "scroll",
                    maxHeight: "90vh",
                    overflowX: "hidden",
                  }}
                >
                  <div
                    style={{
                      border: "3px solid " + themeStyle.primaryCardColor,
                      borderRadius: "15px",
                      padding: "15px",
                    }}
                  >
                    <Grid
                      container
                      spacing={2}
                      style={{
                        justifyContent: "flex-start",
                        textAlign: "left",
                        paddingBottom: "15px",
                        color: themeStyle.primaryColor,
                        borderBottom: "1px solid" + themeStyle.primaryColor,
                        backgroundColor: themeStyle.primaryCardColor,
                        width: "103.2%",
                        borderTopRightRadius: "15px",
                        borderTopLeftRadius: "15px",
                      }}
                    >
                      <Grid item md={1}>
                        Pic
                      </Grid>
                      <Grid item md={4}>
                        Full Name
                      </Grid>
                      <Grid item md={4}>
                        Email
                      </Grid>
                      <Grid item md={2}>
                        Fees Paid
                      </Grid>
                      <Grid item md={1}>
                        Edit
                      </Grid>
                    </Grid>
                    {studentList.map((user, index) => (
                      <Grid
                        onClick={() => setProfile(user)}
                        container
                        style={{
                          backgroundColor:
                            user["user_id"] == profile["user_id"]
                              ? themeStyle.primaryColorLight
                              : "white",
                          color: "black",
                          padding: "15px",
                          alignItems: "center",
                          paddingTop: "23px",
                          borderRadius: "25px",
                        }}
                      >
                        <Grid item md={1}>
                          <Avatar
                            sx={{ marginTop: "-7px" }}
                            alt={user["full_name"]}
                            src={API_URL + "/media/" + user["image"]}
                          />
                        </Grid>
                        <Grid
                          style={{ cursor: "pointer" }}
                          onClick={() => setProfile(user)}
                          item
                          md={4}
                        >
                          {user["full_name"]}
                        </Grid>
                        <Grid item md={4}>
                          {user["email"]}
                        </Grid>

                        <Grid item md={2} style={{ textAlign: "center" }}>
                          {user["fees_paid"]}
                        </Grid>
                        <Grid item md={1} style={{ textAlign: "center" }}>
                          <EditIcon
                            onClick={() => {
                              setProfile(user);
                              setOpen(true);
                            }}
                            style={{
                              color: themeStyle.primaryColor,
                              cursor: "pointer",
                            }}
                          />
                        </Grid>
                      </Grid>
                    ))}
                  </div>
                  {ogStudents.length > 15 ? (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginBottom: "-15px",
                        marginTop: "-15px",
                      }}
                    >
                      {Array.from(
                        Array(Math.ceil(ogStudents.length / 25)).keys()
                      ).map((temp, index) => (
                        <div
                          style={{
                            cursor: "pointer",
                            margin: "3px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "25px",
                            height: "25px",
                            borderRadius: "30px",
                            color: "white",
                            backgroundColor: themeStyle.primaryColor,
                          }}
                          onClick={() => {
                            handleCurrentPage(index + 1);
                          }}
                        >
                          {index + 1}
                        </div>
                      ))}
                    </div>
                  ) : (
                    ""
                  )}
                </Grid>
              </Grid>
            </div>
          </div>
        )}
      </div>
    );
  }

  if (!state.auth.isLoading) {
    if (state.auth.isAuthenticated) {
      if (state.auth.user.is_teacher) {
        if (isLoading) {
          return (
            <Fragment>
              <Sidebar />
              <div
                style={{
                  maxWidth: "88vw",
                  marginTop: "45vh",
                  marginLeft: "8vw",
                  height: "100%",
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <CircularProgress />
              </div>
            </Fragment>
          );
        } else {
          return (
            <Fragment>
              <Sidebar
                tabs={
                  noClasses ? (
                    ""
                  ) : (
                    <Grid container spacing={1.5}>
                      <Grid item md={2}>
                        {ogStudents.length + " Students"}
                      </Grid>
                      <Grid item md={2}>
                        <Select
                          value={classs}
                          onChange={(e) => handleClassChange(e)}
                          style={{
                            height: "40px",
                            marginTop: "2px",
                          }}
                          fullWidth
                          variant={"outlined"}
                        >
                          {getClassList()}
                        </Select>
                      </Grid>
                      <Grid item md={2}>
                        <Select
                          value={division}
                          onChange={(e) => handleDivisionChange(e)}
                          style={{
                            height: "40px",
                            marginTop: "2px",
                          }}
                          fullWidth
                          variant={"outlined"}
                        >
                          {getDivisionList()}
                        </Select>
                      </Grid>
                      <Grid item md={6}>
                        <TextField
                          fullWidth
                          id="outlined-basic"
                          placeholder="Search User / Email"
                          variant="outlined"
                          value={search}
                          size="small"
                          style={{
                            height: "40px",
                            marginTop: "2px",
                          }}
                          onChange={(e) => handleSearch(e.target.value)}
                        />
                      </Grid>
                    </Grid>
                  )
                }
              />

              <Modal
                open={open}
                onClose={() => setOpen(false)}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                  timeout: 500,
                }}
              >
                <Fade in={open}>
                  <div
                    style={{
                      borderRadius: "25px",
                      position: "absolute",
                      top: "50%",
                      backgroundColor: "white",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      width: 500,
                      padding: "15px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    {" "}
                    {console.log(profile)}
                    <div style={{ marginTop: "-25px", width: "100%" }}>
                      <div
                        style={{
                          marginTop: "20px",
                          display: "flex",
                          justifyContent: "space-between",
                          width: "100%",
                        }}
                      >
                        <h3>Optional Subjects for {profile.full_name} </h3>

                        <IconButton size="small">
                          <CloseIcon
                            onClick={() => setOpen(false)}
                            style={{ color: themeStyle.primaryColor }}
                          />
                        </IconButton>
                      </div>
                      <br />
                      {optionalSubjectsList.map((subject) => (
                        <div
                          style={{ display: "flex", alignItems: "center" }}
                          key={subject}
                        >
                          <Checkbox
                            disableRipple={true}
                            labelStyle={{ color: themeStyle.primaryColor }}
                            iconStyle={{ fill: "white" }}
                            checked={profile["subject_list"].includes(subject)}
                            onChange={(e) => {
                              if (e.target.checked) {
                                var tempProfile = profile;
                                tempProfile["subject_list"].push(subject);
                                setProfile(tempProfile);
                                setRandom(makeid(5));
                              } else {
                                var tempProfile = profile;
                                tempProfile["subject_list"].splice(
                                  tempProfile["subject_list"].indexOf(subject),
                                  1
                                );
                                setProfile(tempProfile);
                                setRandom(makeid(5));
                              }
                            }}
                            value={1}
                            style={{
                              color: themeStyle.primaryColor,
                            }}
                          />
                          <div
                            style={{ textAlign: "center", marginTop: "0px" }}
                          >
                            {subject}
                          </div>
                        </div>
                      ))}
                      <br />

                      <div
                        style={{
                          display: "flex",
                          width: "100%",
                          justifyContent: "flex-end",
                        }}
                      >
                        <Button
                          style={{
                            height: "30px",
                            backgroundColor: themeStyle.primaryColor,
                          }}
                          variant="contained"
                          onClick={() => setOpen(false)}
                        >
                          Cancel
                        </Button>
                        <Button
                          onClick={() => {
                            changeOptionalSubjects();
                          }}
                          style={{
                            height: "30px",
                            marginLeft: "10px",
                            backgroundColor: themeStyle.primaryColor,
                          }}
                          variant="contained"
                        >
                          Submit
                        </Button>
                      </div>
                    </div>
                  </div>
                </Fade>
              </Modal>

              <div
                style={{
                  borderRadius: "15px",
                  margin: "45px 0px 20px 70px",
                  backgroundColor: "white",
                }}
              >
                {" "}
                {noClasses ? (
                  <div
                    style={{
                      marginTop: "200px",
                      height: "100px",
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <div style={{ textAlign: "center" }}>
                      <Fab
                        size="large"
                        style={{
                          border: "3px solid #aaa",
                          boxShadow: "none",
                          backgroundColor: "transparent",
                        }}
                        aria-label="add"
                      >
                        <PriorityHighIcon
                          style={{
                            color: "grey",
                          }}
                        />
                      </Fab>
                      <br />
                      <h4 style={{ color: "grey" }}>
                        No classes or subjects appointed.
                      </h4>
                    </div>
                  </div>
                ) : (
                  getContent()
                )}
              </div>
            </Fragment>
          );
        }
      } else {
        dispatch({ type: "AUTH_ERROR" });
      }
    } else {
      dispatch({ type: "AUTH_ERROR" });
    }
  } else {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          marginTop: "46vh",
        }}
      >
        <CircularProgress />
      </div>
    );
  }
}

export default Students;
